import React, { Component } from 'react'
import { action, computed } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import inject from 'helpers/inject'
import formField from 'helpers/formField'

import Card, { CardContent, CardActions } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import FormInput from 'components/forms/FormInput'
import AsyncButton from 'components/AsyncButton'

import AuthService from 'services/auth'

import changePassword from 'tasks/changePassword'

import styles from 'styles/components/ChangePasswordForm'

@withStyles(styles)
@observer
export default class extends Component {

  auth = inject(AuthService)

  @computed
  get oldPassword() {
    return formField({
      value: '',
      label: 'Старый пароль',
      type: 'password',
      name: 'oldPassword',
      validations: {
        presence: true
      }
    })
  }

  @computed
  get newPassword() {
    return formField({
      value: '',
      label: 'Новый пароль',
      name: 'newPassword',
      type: 'password',
      validations: {
        presence: true,
        length: { minimum: 6, tooShort: 'Пароль должен содержать не менее 6 символов' },
        nonEqualityTo: {
          value: this.oldPassword.value,
          message: 'Пароли не должны быть одинаковыми'
        }
      }
    })
  }

  @computed
  get newPasswordConfirm() {
    return formField({
      value: '',
      label: 'Подтверждение нового пароля',
      name: 'newPasswordConfirm',
      type: 'password',
      validations: {
        presence: true,
        length: { minimum: 6, tooShort: 'Пароль должен содержать не менее 6 символов' },
        equalityTo: {
          value: this.newPassword.value,
          message: 'Пароли не совпадают'
        }
      }
    })
  }

  @computed
  get fields() {
    return [ this.oldPassword, this.newPassword, this.newPasswordConfirm ]
  }

  @computed
  get hasErrors() {
    return this.fields.filter(field => field.hasErrors).length > 0
  }

  render() {
    const { classes } = this.props

    return (
      <Card elevation={1} className={ classes.card } >
        <AppBar elevation={0} position="static" color="default">
          <Toolbar className={ classes.toolbar }>
            <Typography type='body2' >
              Смена пароля
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={ classes.wrapper } >
          <CardContent className={ classes.content } >

            { this.fields.map(( field, index ) => (
              <FormInput
                field={ field }
                key={ index }
                TextFieldProps={{
                  fullWidth: true
                }}
              />
            ))}

          </CardContent>
          <CardActions className={ classes.actions } >
            <AsyncButton
              label='Изменить пароль'
              processingLabel='Изменяем...'
              successLabel='Пароль изменен!'
              action={ this.handleSave }
              ButtonProps={{
                fullWidth: true,
                raised: true,
                color: 'primary'
              }}
            />
          </CardActions>
        </div>
      </Card>
    )
  }

  @action.bound
  async handleSave() {
    this.fields.forEach(field => field.validate())
    if (this.hasErrors) throw new Error()
    const oldPassword = this.fields.find(field => field.name === 'oldPassword').value
    const newPassword = this.fields.find(field => field.name === 'newPassword').value
    const newPasswordConfirm = this.fields.find(field => field.name === 'newPasswordConfirm').value
    await changePassword.perform(this.auth.user.id, { oldPassword, newPassword, newPasswordConfirm })
  }

}




// WEBPACK FOOTER //
// ./src/components/ChangePasswordForm.js